import type { Store } from 'redux';

import { API_DATE_FORMAT } from '../../../../../../constants';

import type { RootState } from '../../../../../../store';
import type { FormFieldName } from '../../../../../common';
import type {
  AssessmentInfoFieldName,
  AssessmentInfoFormValues,
  AssessmentReadinessDateFormValues,
} from '../types';

export function isTreatmentPlanV3CrisisMutating(state: RootState) {
  return (
    state.treatmentPlanV3.createCrisisPlanLoading ||
    state.treatmentPlanV3.updateCrisisPlanLoading ||
    state.treatmentPlanV3.deleteCrisisPlanLoading ||
    state.treatmentPlanV3.deleteAllCrisisPlansLoading ||
    state.treatmentPlanV3.setNoCrisisPlanNeededLoading
  );
}

export function waitForTreatmentPlanV3CrisisIdle(store: Store<RootState>) {
  return new Promise<void>((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      unsubscribe();
      resolve();
    };
    const unsubscribe = store.subscribe(() => {
      if (!isTreatmentPlanV3CrisisMutating(store.getState())) finish();
    });
    if (!isTreatmentPlanV3CrisisMutating(store.getState())) finish();
  });
}

export function getAssessmentInfoFieldCompareValue(
  name: AssessmentInfoFieldName,
  values: AssessmentInfoFormValues,
) {
  if (name === 'initial_assessment_date' || name === 'reassessment_date') {
    return values[name]?.format(API_DATE_FORMAT) ?? '';
  }
  if (name === 'additional_files_viewed') {
    return values.additional_files_viewed.join('\0');
  }
  return values[name];
}

export function getAssessmentReadinessDateCompareValue(
  _name: FormFieldName<AssessmentReadinessDateFormValues>,
  values: AssessmentReadinessDateFormValues,
) {
  return values.telehealth_assessment_date?.format(API_DATE_FORMAT) ?? '';
}
